import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import { connectRouter, routerMiddleware } from "connected-react-router";
import thunk from "redux-thunk";
import { api, currentUser, personalTeam, entities, ui } from ".";
import apiMiddleware from "./middleware/api";
import facebookPixel from "./middleware/facebookPixel";
import pathnameMiddleware from "./middleware/pathname";
import notificationMiddleware from "./middleware/notification";
import fonts from "./middleware/fonts";
import appsignalMiddleware from "./middleware/appsignal";

const REDUX_DEV_TOOL = process.env.REACT_APP_REDUX_DEV_TOOL;

const configStore = history => {
  const middlewares = [
    thunk,
    appsignalMiddleware, // Capture all actions and state for error context
    pathnameMiddleware,
    notificationMiddleware,
    apiMiddleware,
    facebookPixel,
    fonts,
    routerMiddleware(history)
  ];

  let composeEnhancers = compose;

  if (
    REDUX_DEV_TOOL === "true" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ) {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25
    });
  }

  const combined = combineReducers({
    api,
    ui,
    currentUser,
    personalTeam,
    entities,
    router: connectRouter(history)
  });

  const store = createStore(
    combined,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  return store;
};

export default configStore;
